function _instanceof(left, right) {
  return null != right && "undefined" != typeof Symbol && right[Symbol.hasInstance] ? right[Symbol.hasInstance](left) : left instanceof right;
}

function _typeof(obj) {
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!_instanceof(instance, Constructor)) throw new TypeError("Cannot call a class as a function");
}

function _possibleConstructorReturn(self, call) {
  return call && ("object" === _typeof(call) || "function" == typeof call) ? call : _assertThisInitialized(self);
}

function _defineProperties(target, props) {
  for (var descriptor, i = 0; i < props.length; i++) {
    descriptor = props[i], descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, "value" in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  return protoProps && _defineProperties(Constructor.prototype, protoProps), staticProps && _defineProperties(Constructor, staticProps), Constructor;
}

function _inherits(subClass, superClass) {
  if ("function" != typeof superClass && null !== superClass) throw new TypeError("Super expression must either be null or a function");
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: !0,
      configurable: !0
    }
  }), superClass && _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  return _setPrototypeOf = Object.setPrototypeOf || function (o, p) {
    return o.__proto__ = p, o;
  }, _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (void 0 === self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return self;
}

import { PureComponent, createElement } from "react";
import PropTypes from "prop-types";
import StaticMap from "./static-map";
import { MAPBOX_LIMITS } from "../utils/map-state";
import WebMercatorViewport from "viewport-mercator-project";
import TransitionManager from "../utils/transition-manager";
import { getInteractiveLayerIds } from "../utils/style-utils";
import { EventManager } from "mjolnir.js";
import MapControls from "../utils/map-controls";
import config from "../config";
import deprecateWarn from "../utils/deprecate-warn";

var propTypes = Object.assign({}, StaticMap.propTypes, {
  maxZoom: PropTypes.number,
  minZoom: PropTypes.number,
  maxPitch: PropTypes.number,
  minPitch: PropTypes.number,
  onViewStateChange: PropTypes.func,
  onViewportChange: PropTypes.func,
  transitionDuration: PropTypes.number,
  transitionInterpolator: PropTypes.object,
  transitionInterruption: PropTypes.number,
  transitionEasing: PropTypes.func,
  onTransitionStart: PropTypes.func,
  onTransitionInterrupt: PropTypes.func,
  onTransitionEnd: PropTypes.func,
  scrollZoom: PropTypes.bool,
  dragPan: PropTypes.bool,
  dragRotate: PropTypes.bool,
  doubleClickZoom: PropTypes.bool,
  touchZoom: PropTypes.bool,
  touchRotate: PropTypes.bool,
  keyboard: PropTypes.bool,
  onHover: PropTypes.func,
  onClick: PropTypes.func,
  onContextMenu: PropTypes.func,
  touchAction: PropTypes.string,
  clickRadius: PropTypes.number,
  getCursor: PropTypes.func,
  mapControls: PropTypes.shape({
    events: PropTypes.arrayOf(PropTypes.string),
    handleEvent: PropTypes.func
  })
}),
    getDefaultCursor = function getDefaultCursor(_ref) {
  var isDragging = _ref.isDragging,
      isHovering = _ref.isHovering;
  return isDragging ? config.CURSOR.GRABBING : isHovering ? config.CURSOR.POINTER : config.CURSOR.GRAB;
},
    defaultProps = Object.assign({}, StaticMap.defaultProps, MAPBOX_LIMITS, TransitionManager.defaultProps, {
  onViewStateChange: null,
  onViewportChange: null,
  onClick: null,
  onHover: null,
  onContextMenu: function onContextMenu(event) {
    return event.preventDefault();
  },
  scrollZoom: !0,
  dragPan: !0,
  dragRotate: !0,
  doubleClickZoom: !0,
  touchAction: "none",
  clickRadius: 0,
  getCursor: getDefaultCursor
}),
    childContextTypes = {
  viewport: PropTypes.instanceOf(WebMercatorViewport),
  isDragging: PropTypes.bool,
  eventManager: PropTypes.object
},
    InteractiveMap = function (_PureComponent) {
  function InteractiveMap(props) {
    var _this;

    return _classCallCheck(this, InteractiveMap), _this = _possibleConstructorReturn(this, (InteractiveMap.__proto__ || Object.getPrototypeOf(InteractiveMap)).call(this, props)), deprecateWarn(props), _this.state = {
      isDragging: !1,
      isHovering: !1
    }, _this._mapControls = props.mapControls || new MapControls(), _this._eventManager = new EventManager(null, {
      legacyBlockScroll: !1,
      touchAction: props.touchAction
    }), _this._updateQueryParams(props.mapStyle), _this.getMap = _this.getMap.bind(_assertThisInitialized(_this)), _this.queryRenderedFeatures = _this.queryRenderedFeatures.bind(_assertThisInitialized(_this)), _this._getFeatures = _this._getFeatures.bind(_assertThisInitialized(_this)), _this._updateQueryParams = _this._updateQueryParams.bind(_assertThisInitialized(_this)), _this._onInteractiveStateChange = _this._onInteractiveStateChange.bind(_assertThisInitialized(_this)), _this._getPos = _this._getPos.bind(_assertThisInitialized(_this)), _this._eventCanvasLoaded = _this._eventCanvasLoaded.bind(_assertThisInitialized(_this)), _this._staticMapLoaded = _this._staticMapLoaded.bind(_assertThisInitialized(_this)), _this;
  }

  return _inherits(InteractiveMap, _PureComponent), _createClass(InteractiveMap, null, [{
    key: "supported",
    value: function supported() {
      return StaticMap.supported();
    }
  }]), _createClass(InteractiveMap, [{
    key: "getChildContext",
    value: function getChildContext() {
      return {
        viewport: new WebMercatorViewport(this.props),
        isDragging: this.state.isDragging,
        eventManager: this._eventManager
      };
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var eventManager = this._eventManager;
      eventManager.on({
        mousemove: this._onMouseMove.bind(this),
        click: this._onMouseClick.bind(this),
        contextmenu: this._onContextMenu.bind(this)
      }), this._mapControls.setOptions(Object.assign({}, this.props, this.props.viewState, {
        onStateChange: this._onInteractiveStateChange,
        eventManager: eventManager
      })), this._transitionManager = new TransitionManager(this.props);
    }
  }, {
    key: "componentWillUpdate",
    value: function componentWillUpdate(nextProps) {
      this.props.mapStyle !== nextProps.mapStyle && this._updateQueryParams(nextProps.mapStyle);
      var nextPropsWithViewState = Object.assign({}, nextProps, nextProps.viewState);
      this._mapControls.setOptions(nextPropsWithViewState), this._transitionManager.processViewportChange(nextPropsWithViewState);
    }
  }, {
    key: "getMap",
    value: function getMap() {
      return this._map ? this._map.getMap() : null;
    }
  }, {
    key: "queryRenderedFeatures",
    value: function queryRenderedFeatures(geometry, options) {
      return this._map.queryRenderedFeatures(geometry, options);
    }
  }, {
    key: "_getFeatures",
    value: function _getFeatures(_ref2) {
      var features,
          pos = _ref2.pos,
          radius = _ref2.radius;

      if (radius) {
        var size = radius,
            bbox = [[pos[0] - size, pos[1] + size], [pos[0] + size, pos[1] - size]];
        features = this._map.queryRenderedFeatures(bbox, this._queryParams);
      } else features = this._map.queryRenderedFeatures(pos, this._queryParams);

      return features;
    }
  }, {
    key: "_updateQueryParams",
    value: function _updateQueryParams(mapStyle) {
      var interactiveLayerIds = getInteractiveLayerIds(mapStyle);
      this._queryParams = {
        layers: interactiveLayerIds
      };
    }
  }, {
    key: "_onInteractiveStateChange",
    value: function _onInteractiveStateChange(_ref3) {
      var _ref3$isDragging = _ref3.isDragging,
          isDragging = void 0 !== _ref3$isDragging && _ref3$isDragging;
      isDragging !== this.state.isDragging && this.setState({
        isDragging: isDragging
      });
    }
  }, {
    key: "_getPos",
    value: function _getPos(event) {
      var _event$offsetCenter = event.offsetCenter,
          x = _event$offsetCenter.x,
          y = _event$offsetCenter.y;
      return [x, y];
    }
  }, {
    key: "_onMouseMove",
    value: function _onMouseMove(event) {
      if (!this.state.isDragging) {
        var pos = this._getPos(event),
            features = this._getFeatures({
          pos: pos,
          radius: this.props.clickRadius
        }),
            isHovering = features && 0 < features.length;

        if (isHovering !== this.state.isHovering && this.setState({
          isHovering: isHovering
        }), this.props.onHover) {
          var viewport = new WebMercatorViewport(this.props);
          event.lngLat = viewport.unproject(pos), event.features = features, this.props.onHover(event);
        }
      }
    }
  }, {
    key: "_onMouseClick",
    value: function _onMouseClick(event) {
      if (this.props.onClick) {
        var pos = this._getPos(event),
            viewport = new WebMercatorViewport(this.props);

        event.lngLat = viewport.unproject(pos), event.features = this._getFeatures({
          pos: pos,
          radius: this.props.clickRadius
        }), this.props.onClick(event);
      }
    }
  }, {
    key: "_onContextMenu",
    value: function _onContextMenu(event) {
      this.props.onContextMenu && this.props.onContextMenu(event);
    }
  }, {
    key: "_eventCanvasLoaded",
    value: function _eventCanvasLoaded(ref) {
      this._eventManager.setElement(ref);
    }
  }, {
    key: "_staticMapLoaded",
    value: function _staticMapLoaded(ref) {
      this._map = ref;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          width = _this$props.width,
          height = _this$props.height,
          getCursor = _this$props.getCursor,
          eventCanvasStyle = {
        width: width,
        height: height,
        position: "relative",
        cursor: getCursor(this.state)
      };
      return createElement("div", {
        key: "map-controls",
        ref: this._eventCanvasLoaded,
        style: eventCanvasStyle
      }, createElement(StaticMap, Object.assign({}, this.props, this._transitionManager && this._transitionManager.getViewportInTransition(), {
        ref: this._staticMapLoaded,
        children: this.props.children
      })));
    }
  }]), InteractiveMap;
}(PureComponent);

export { InteractiveMap as default };
InteractiveMap.displayName = "InteractiveMap", InteractiveMap.propTypes = propTypes, InteractiveMap.defaultProps = defaultProps, InteractiveMap.childContextTypes = childContextTypes;